module.exports = __webpack_public_path__ + "img/Weapon_263.d1c42ff7.png";